var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',[_c('BaseCardBody',[_c('SectionHeader',{attrs:{"title":"SMS Campaign Setting","description":"Update SMS campaign settings."}})],1),_c('BaseCardBody',[_c('SmsCampaignForm',{attrs:{"account-id":_vm.smsCampaign.account_id,"default-data":_vm.smsCampaign,"from-options":_vm.fromOptions,"action":_vm.update,"disabled":!_vm.canEdit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }